import { render, staticRenderFns } from "./ButtonList.vue?vue&type=template&id=5cd3cec8&scoped=true"
import script from "./ButtonList.js?vue&type=script&lang=js&external"
export * from "./ButtonList.js?vue&type=script&lang=js&external"
import style0 from "./ButtonList.scss?vue&type=style&index=0&id=5cd3cec8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd3cec8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotIcon: require('/home/runner/_work/app-hotmart-jobs/app-hotmart-jobs/components/Atoms/Icon/Icon.vue').default})
